import type { AppointmentType, CalendarPresets } from "../types";

/** Existing records remain editable even when a clinic disables new calls. */
export function canOpenAppointmentEditor({
  editing,
  presets,
  typedEventsEnabled,
  requestedType,
}: {
  editing: boolean;
  presets?: CalendarPresets | null;
  typedEventsEnabled: boolean;
  requestedType?: AppointmentType;
}): boolean {
  if (editing) return true;
  const clinicTypes: AppointmentType[] = typedEventsEnabled
    ? ["clinic_visit", "lead_call", "internal"]
    : ["clinic_visit"];
  const roleTypes = presets?.creatable_types ?? (
    presets?.lock_create_type && presets.default_create_type
      ? [presets.default_create_type]
      : clinicTypes
  );
  return roleTypes.some(type => clinicTypes.includes(type) && (!requestedType || type === requestedType));
}
